export default class FormFollow {
  constructor () {
    this.storageData = {
      user: '',
      pwd: '',
      repositoryName: '',
      comments: ''
    }
  }
}
